module.exports = __webpack_public_path__ + "img/userB08.fac8773b.jpg";